import moment from 'moment';

const formatDate = (format: string) => (date: Object) => moment(date).format(format);
const formatToShow = formatDate('DD MMM YYYY');
const formatForApi = formatDate('YYYY-MM-DD');

export {
  formatToShow,
  formatForApi,
};


// WEBPACK FOOTER //
// ./src/lib/helpers/dateFormatter.js